import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { GoogleOAuthProvider } from '@react-oauth/google'
import i18n from 'config/i18n'

import Root from './components/Root'
import { configureStore } from './state'
import { initAmplitude } from 'config/analytics'
import 'react-datepicker/dist/react-datepicker.css'
import { PersistGate } from 'redux-persist/es/integration/react'
import { ThemeProvider } from 'particles/themes/styled'
import light from 'particles/themes/light'

const initialState = (window as any).initialReduxState
const history = createBrowserHistory()
export const { store, persistor } = configureStore(initialState, history)

if (process.env.ENVIRONMENT !== 'production') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const whyDidYouRender = require('@welldone-software/why-did-you-render/dist/no-classes-transpile/umd/whyDidYouRender.min.js')
    whyDidYouRender(React, { trackHooks: true })
}

const App: React.FC = () => {
    useEffect(() => {
        initAmplitude()
    }, [])

    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? ''}>
            <I18nextProvider i18n={i18n}>
                <Provider store={store}>
                    <PersistGate persistor={persistor}>
                        <ThemeProvider theme={light}>
                            <ConnectedRouter history={history}>
                                <Root />
                            </ConnectedRouter>
                        </ThemeProvider>
                    </PersistGate>
                </Provider>
            </I18nextProvider>
        </GoogleOAuthProvider>
    )
}

export default App
